// CÂU HOOK + LIÊN KẾT QUẢNG BÁ trong Giọng điệu của sơ đồ (16/10/2026) — file lá (không import gì) để so-do.ts dùng được. Xem thiet-lap-nhanh.ts.
// ---------------------------------------------------------------------------------------------------------------------------------------
// Hook + liên kết trong Giọng điệu
export const NOI = " | ";
export const DAU_HOOK = "Mở đầu mỗi nội dung bằng một câu hook ngắn gây chú ý, hợp nội dung bài.";
const GOI_Y_HOOK = " Gợi ý kiểu hook: ";
export const DAU_LIEN_KET = "Cuối mỗi bình luận / bài đăng LUÔN chèn nguyên văn liên kết này: ";
export const HOOK_TOI_DA = 120;
export const LIEN_KET_TOI_DA = 200;
const RE_LIEN_KET = /^https?:\/\/[^\s|]{3,}$/i;

export interface LoiVanNhanh { goc: string; hook: boolean; goiYHook: string; lienKet: string }

const mot = (s: string): string => s.replace(/\s+/g, " ").replace(/ \| /g, " - ").trim();

/** Tách Giọng điệu thành phần người dùng viết (goc) + hook + liên kết. Không có dấu nhận biết → goc = nguyên văn. */
export function docLoiVanNhanh(giongDieu: string | undefined): LoiVanNhanh {
  let t = NOI + (giongDieu ?? "");
  let lienKet = "";
  let hook = false;
  let goiYHook = "";
  const iLink = t.lastIndexOf(NOI + DAU_LIEN_KET);
  if (iLink >= 0) {
    const v = t.slice(iLink + NOI.length + DAU_LIEN_KET.length);
    if (!v.includes(NOI)) { lienKet = v; t = t.slice(0, iLink); }
  }
  const iHook = t.lastIndexOf(NOI + DAU_HOOK);
  if (iHook >= 0) {
    const v = t.slice(iHook + NOI.length + DAU_HOOK.length);
    if (v === "" || (v.startsWith(GOI_Y_HOOK) && !v.includes(NOI))) { hook = true; goiYHook = v.slice(GOI_Y_HOOK.length); t = t.slice(0, iHook); }
  }
  return { goc: t.slice(NOI.length), hook, goiYHook, lienKet };
}

/** Ngược của docLoiVanNhanh: ghép lại Giọng điệu. */
export function ghiLoiVanNhanh(v: { goc: string; hook: boolean; goiYHook?: string; lienKet?: string }): string {
  const phan: string[] = [];
  if (v.goc) phan.push(v.goc);
  if (v.hook) phan.push(DAU_HOOK + (mot(v.goiYHook ?? "") ? GOI_Y_HOOK + mot(v.goiYHook ?? "") : ""));
  const lk = (v.lienKet ?? "").trim();
  if (lk) phan.push(DAU_LIEN_KET + lk);
  return phan.join(NOI);
}

/** Kiểm đầu vào của người dùng; trả câu lỗi hoặc null. */
export function kiemLoiVanNhanh(v: { goiYHook?: string; lienKet?: string }): string | null {
  if (Array.from(v.goiYHook ?? "").length > HOOK_TOI_DA) return `Gợi ý câu hook tối đa ${HOOK_TOI_DA} ký tự`;
  const lk = (v.lienKet ?? "").trim();
  if (lk && (lk.length > LIEN_KET_TOI_DA || !RE_LIEN_KET.test(lk))) return `Liên kết phải bắt đầu bằng http:// hoặc https://, không có dấu cách, tối đa ${LIEN_KET_TOI_DA} ký tự`;
  return null;
}
// ---------------------------------------------------------------------------------------------------------------------------------------
// Liên kết quảng bá: nằm trong Giọng điệu của SƠ ĐỒ (dòng cuối "…| Cuối mỗi bình luận … liên kết này: <url>") nhưng bản chạy được KHÔNG đưa nó cho AI soạn —
// bộ kiểm nội dung (plugin) loại mọi câu có liên kết ("có liên kết", "mời chào lộ liễu") nên liên kết do plugin NỐI TẤT ĐỊNH sau khi câu đã qua kiểm
// (knowledge.lien_ket → src/background/runner.ts). Lỗi người dùng báo 16/10: "comment có chèn link nhưng đăng ra chỉ thấy chữ".
/** Tách liên kết khỏi Giọng điệu của sơ đồ: trả giọng điệu không có dòng liên kết + liên kết (rỗng nếu không có). */
export function tachLienKet(giongDieu: string | undefined): { giongDieu: string | undefined; lienKet: string } {
  if (giongDieu === undefined) return { giongDieu, lienKet: "" };
  const v = docLoiVanNhanh(giongDieu);
  if (!v.lienKet) return { giongDieu, lienKet: "" };
  return { giongDieu: ghiLoiVanNhanh({ goc: v.goc, hook: v.hook, goiYHook: v.goiYHook }), lienKet: v.lienKet };
}
/** Ngược của tachLienKet: nối liên kết (knowledge.lien_ket) lại vào Giọng điệu của sơ đồ. */
export function gopLienKet(giongDieu: unknown, lienKet: unknown): unknown {
  if (typeof lienKet !== "string" || !lienKet.trim()) return giongDieu;
  const g = typeof giongDieu === "string" ? giongDieu : "";
  return g ? `${g}${NOI}${DAU_LIEN_KET}${lienKet.trim()}` : `${DAU_LIEN_KET}${lienKet.trim()}`;
}
